module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-8.ac96cfa4.jpg";